<template>
  <div class="error-page">
    <div class="error-code">404</div>
    <div class="error-desc">抱歉，您访问的页面不存在</div>
    <div class="actions">
      <el-button type="primary" @click="goHome">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  color: #1890ff;
  margin-bottom: 20px;
}

.error-desc {
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
}

.actions {
  margin-top: 20px;
}
</style> 